<template>
  <div>
    <top-notification v-if="showAdditionalRecipientInactive">
      <inactive-additional-recipient />
    </top-notification>

    <top-notification v-if="showNoForm1583">
      <form-1583 />
    </top-notification>

    <top-notification v-if="showNoDocuments">
      <div class="sm-notification-top__documents" @click="$router.push('/customer/account?notarize=1')">
        <include-svg :name="'icon-warning'" />
        <span>The required documentation has not been provided. Please upload <a href="#" @click.prevent>here</a>.</span>
      </div>
    </top-notification>
    <top-notification v-if="showExpiredPhotoId">
      <photo-id-expiration />
    </top-notification>

    <payments-notification v-if="showNoCard || showNoGateway" :notifType="showNoCard ? 'card' : 'gateway'"
      @close="closePaymentsNotif" />

    <reminders-notification v-if="showReminders" />

    <terms-notification v-if="showTerms" @close="canShowTerms = false" />

    <approve-notification v-if="showApprove" @close="approveClosed = true" />

    <email-notification v-if="showEmail" />

    <schedule-notification v-if="showScheduleNotif" @close="closeScheduleNotif" />

    <hubspot-notification v-if="showHubspotNotif" @close="closeHubspotNotif" />

    <quickbooks-notification v-if="showQuickbooksNotif" @close="closeQuickbooksNotif" />

    <deskworks-notification v-if="showDeskworksNotif" @close="closeDeskworksNotif" />

    <!-- <nexudus-notification
      v-if="showNexudusNotif"
      @close="closeNexudusNotif"
    /> -->
  </div>
</template>

<script>
import TopNotification from '@/components/TopNotification';
import Form1583Notification from '@/components/Form1583Notification';
import InactiveAdditionalRecipient from '@/components/InactiveAdditionalRecipient';
import PhotoIDExpirationNotification from '@/components/PhotoIDExpirationNotification';
import { mapActions, mapGetters } from 'vuex';

import TermsNotification from '@/components/notifications/TermsNotification';
import PaymentsNotification from '@/components/notifications/PaymentsNotification';
import RemindersNotification from '@/components/notifications/RemindersNotification';
import ApproveNotification from '@/components/notifications/ApproveNotification';
import EmailNotification from '@/components/notifications/EmailNotification';
import ScheduleNotification from '@/components/notifications/SchedulePickupNotification';
import HubspotNotification from '@/components/notifications/HubspotNotification';
import DeskworksNotification from '@/components/notifications/DeskworksNotification';
import QuickbooksNotification from '@/components/notifications/QuickbooksNotification';
import NexudusNotification from '@/components/notifications/NexudusNotification';


export default {
  name: 'top-notifications',
  components: {
    'top-notification': TopNotification,
    'form-1583': Form1583Notification,
    'photo-id-expiration': PhotoIDExpirationNotification,

    'terms-notification': TermsNotification,
    'payments-notification': PaymentsNotification,
    'reminders-notification': RemindersNotification,
    'approve-notification': ApproveNotification,
    'email-notification': EmailNotification,
    'schedule-notification': ScheduleNotification,
    'hubspot-notification': HubspotNotification,
    'deskworks-notification': DeskworksNotification,
    'quickbooks-notification': QuickbooksNotification,
    'nexudus-notification': NexudusNotification,
    'inactive-additional-recipient': InactiveAdditionalRecipient,
  },
  data() {
    return {
      gateway: null,
      canShowTerms: false,
      noGatewayClosed: localStorage.getItem('no-gateway-closed'),
      noCardClosed: localStorage.getItem('no-card-closed'),
      approveClosed: false,
      scheduleNotifClosed: localStorage.getItem('schedule-notif-closed'),
      schedulingConfigured: true, // temp before load
      hubspotNotifClosed: localStorage.getItem('hubspot-notif-closed'),
      deskworksNotifClosed: localStorage.getItem('deskworks-notif-closed'),
      quickbooksNotifClosed: localStorage.getItem('quickbooks-notif-closed'),
      nexudusNotifClosed: localStorage.getItem('nexudus-notif-closed')
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user',
      provider: 'provider',
      userAccount: 'account/userAccount',
      isAdmin: 'isAdmin',
      reminders: 'mail/reminders',
      form1583Signed: 'account/form1583Signed',
      customersList: 'customers/customersList',
      customerAccount: 'customers/currentCustomer',
    }),
    showNoForm1583() {
      return (
        !this.user.privileged_user && !this.form1583Signed &&
        // !this.user.is_form_1583_pending &&
        this.$route.name !== 'notarize-form1583'
      );
    },
    showAdditionalRecipientInactive() {
      return this.user.type == "AdditionalRecipient" && this.user.additional_recipient_status == 'inactive'
    },
    showNoGateway() {
      return (
        this.provider.client_level != 1 &&
        this.gateway &&
        this.gateway.provider == 'spreedly' &&
        this.gateway.credentials.processor == 'spheremail' &&
        !this.isAdmin &&
        (
          this.$route.name == 'admin-settings' ||
          !this.noGatewayClosed
        )
      );
    },
    showNoCard() {
      return (
        this.user.privileged_user &&
        !this.user.client_access_allowed &&
        !this.isAdmin &&
        (
          this.$route.name == 'admin-settings' ||
          !this.noCardClosed
        )
      )
    },
    showNoDocuments() {
      return (
        !this.user.privileged_user &&
        this.provider.country_id != 1 &&
        this.userAccount.hasOwnProperty('account_approval_status') &&
        this.userAccount.account_approval_status != 'approved' &&
        this.userAccount.documents &&
        this.userAccount.documents.some(item => item.required && !item.file_url)
      )
    },
    showReminders() {
      return (
        this.user.privileged_user &&
        this.reminders &&
        !this.$route.fullPath.includes('/admin/mail?tab=group')
      )
    },
    showTerms() {
      return (
        this.provider.client_level != 1 &&
        this.user.privileged_user &&
        !this.provider.terms_of_service_url &&
        !this.provider.terms_of_service_external_url &&
        this.canShowTerms
      )
    },
    showApprove() {
      return (
        this.user.privileged_user &&
        this.provider.country_id != 1 &&
        this.$route.name == 'admin-customers' &&
        !this.approveClosed &&
        this.customersList.some(customer => {
          return (
            !customer.is_privileged &&
            customer.hasOwnProperty('account_approval_status') &&
            customer.account_approval_status != 'approved' &&
            customer.required_documents_uploaded
          )
        })
      )
    },
    showEmail() {
      return (
        this.user.privileged_user &&
        this.$route.name == 'admin-customer' &&
        this.customerAccount &&
        this.customerAccount.hasOwnProperty('email_exists') &&
        !this.customerAccount.email_exists
      )
    },
    showScheduleNotif() {
      return (
        this.user.privileged_user &&
        this.provider.pick_up_scheduling_enabled &&
        !this.scheduleNotifClosed &&
        !this.schedulingConfigured
      )
    },
    showHubspotNotif() {
      return false;
      // return (
      //   this.user.privileged_user &&
      //   !this.provider.hubspot_api_key &&
      //   !this.hubspotNotifClosed
      // )
    },
    showDeskworksNotif() {
      return false;
      // return (
      //   this.user.privileged_user &&
      //   !this.provider.is_deskworks_connected &&
      //   !this.deskworksNotifClosed
      // )
    },
    showQuickbooksNotif() {
      return false;
      // return (
      //   this.user.privileged_user &&
      //   !this.provider.is_quickbooks_connected &&
      //   !this.quickbooksNotifClosed
      // )
    },
    showNexudusNotif() {
      // return false;
      return (
        this.user.privileged_user &&
        !this.provider.is_nexudus_connected &&
        !this.nexudusNotifClosed
      )
    },
    showExpiredPhotoId() {
      return (
        !this.user.privileged_user &&
        (
          this.user.photo_id_expires_on &&
          new Date(this.user.photo_id_expires_on).getTime() < new Date().getTime()
        )
      )
    }
  },
  created() {
    this.initGateway();
    this.initTerms();
    this.initSchedule();
  },
  methods: {
    ...mapActions({
      getPaymentGateway: 'billing/getPaymentGateway',
      getFeatures: 'general/getFeatures',
      getPickUpSettings: 'general/getPickUpSettings',
    }),
    initGateway() {
      if (this.user.privileged_user && this.provider.payment_gateway == 'spreedly') {
        this.getPaymentGateway()
          .then(res => {
            this.gateway = res;
          });
      }
    },
    closePaymentsNotif(type) {
      if (type == 'card')
        this.noCardClosed = true;
      else
        this.noGatewayClosed = true;
    },
    initTerms() {
      if (this.user.privileged_user)
        this.getFeatures()
          .then(res => {
            if (res && res.hasOwnProperty('terms_of_service_notif') && !res.terms_of_service_notif)
              this.canShowTerms = true;
          })
    },
    initSchedule() {
      if (this.provider.pick_up_scheduling_enabled)
        this.getPickUpSettings()
          .then(res => {
            if (res && res.settings)
              this.schedulingConfigured = res.settings.some(item => item.enabled);
          })
    },
    closeScheduleNotif() {
      this.scheduleNotifClosed = true;
      localStorage.setItem('schedule-notif-closed', true);
    },
    closeHubspotNotif() {
      this.hubspotNotifClosed = true;
      localStorage.setItem('hubspot-notif-closed', true);
    },
    closeDeskworksNotif() {
      this.deskworksNotifClosed = true;
      localStorage.setItem('deskworks-notif-closed', true);
    },
    closeQuickbooksNotif() {
      this.quickbooksNotifClosed = true;
      localStorage.setItem('quickbooks-notif-closed', true);
    },
    closeNexudusNotif() {
      this.nexudusNotifClosed = true;
      localStorage.setItem('nexudus-notif-closed', true);
    }
  }
}
</script>
